export default {
  en: {
    ALL: 'All',
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
  },
  'zh-TW': {
    ALL: '都',
    ACTIVE: '活性',
    COMPLETED: '訖',
  },
};
